import { Component, Inject, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'skychute-svg-loader',
  templateUrl: './svg-loader.component.html',
  styleUrls: ['./svg-loader.component.scss'],
})
export class SvgLoaderComponent {
  @Input() title = '';
  @Input() content: SafeHtml | string = '';

  constructor(
    private domSanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; content: SafeHtml | string },
  ) {
    this.title = data.title;
    if (typeof data.content === 'string') {
      this.content = this.domSanitizer.bypassSecurityTrustHtml(data.content);
    }
  }
}
